import { useQuery } from "react-query";
import { getRiders } from "../../../services/riders";

export const useGetRiders = (isEnabled = true) => {
  return useQuery(
    ["dispatchRiders"],
    () => getRiders().then((res) => res?.data),
    { staleTime: Infinity, enabled: isEnabled },
  );
};
